<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>
  <p>{{ data.message }}</p>
</mat-dialog-content>
@if (isCancelButtonDefault()) {
  <mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="true">{{ 'DIALOGS.CLOSE_FORCE' | translate }}</button>
    <button mat-button [mat-dialog-close]="false" cdkFocusInitial>{{ 'DIALOGS.CANCEL' | translate }}</button>
  </mat-dialog-actions>
}
@if (!isCancelButtonDefault()) {
  <mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="true" cdkFocusInitial>
      {{ 'DIALOGS.CLOSE_FORCE' | translate }}
    </button>
    <button mat-button [mat-dialog-close]="false">{{ 'DIALOGS.CANCEL' | translate }}</button>
  </mat-dialog-actions>
}
